module.exports = __webpack_public_path__ + "img/white_image.818753a7.png";